import classNames from 'classnames'
import { useMemo } from 'react'

interface HighlightProps {
  /**
   * Search string that will be highlighted
   */
  highlight: string
  /**
   * Text to be highlighted
   */
  text: string

  /**
   * Class name for the highlighted text
   */
  highlightClassName?: string
}

export function Highlight({
  highlight,
  text,
  highlightClassName = 'bg-yellow-100 text-yellow-800 dark:bg-transparent dark:text-orange-300',
}: HighlightProps) {
  const index = text.toLowerCase().indexOf(highlight.toLowerCase())

  const processedText = useMemo(
    () => ({
      before: text.substring(0, index),
      highlight: text.substring(index, index + highlight.length),
      after: text.substring(index + highlight.length),
    }),
    [highlight.length, index, text]
  )

  if (index < 0 || highlight.length < 1) return <span>{text}</span>

  return (
    <div className="contents">
      <span className="relative z-10">{processedText.before}</span>
      {!!processedText.highlight.length && (
        <span className={classNames('rounded-sm', highlightClassName)}>{processedText.highlight}</span>
      )}
      <span className="relative z-10">{processedText.after}</span>
    </div>
  )
}
